export default "__VITE_ASSET__C8fZCciU__ 778w";